import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import { presetStateSelector } from "../utils/state.js";
import { getLayers } from "./layersReducer.js";
import { findById } from "../utils/dash.js";
import { setExtraSpec } from "../utils/actions.js";
export const selectSource = createAction("sources/select");
export const setSourcesConfigDisplay = createAction("sources/setConfigDisplay");
export const selectSourceLayer = createAction("sources/selectLayer");
export const selectSourceLayerLayer = createAction("sources/selectLayerLayer");
export const changeSearch = createAction("sources/changeSearch");
export const changeSourceConfig = createAction("sources/changeConfig");
export const addSourceTileJSON = createAction("sources/addSourceTileJSON");
export const addSourceMetadata = createAction("sources/addSourceMetadata");
const initialState = {
    search: "",
    configDisplay: "code",
    selectedSource: null,
    selectedSourceLayer: null,
    selectedSourceLayerLayer: null,
    sources: {},
    tilejson: {},
    metadata: {},
};
export const sourcesReducer = createReducer(initialState, (builder) => {
    // @ts-expect-error Immer and complex intersection types from maplibre do not work well together
    builder
        .addCase(selectSource, (state, { payload }) => {
        state.selectedSource = payload;
    })
        .addCase(selectSourceLayer, (state, { payload }) => {
        state.selectedSourceLayer = payload;
    })
        .addCase(selectSourceLayerLayer, (state, { payload }) => {
        state.selectedSourceLayerLayer = payload;
    })
        .addCase(setSourcesConfigDisplay, (state, { payload }) => {
        state.configDisplay = payload;
    })
        .addCase(addSourceTileJSON, (state, { payload }) => {
        const { url, tilejson } = payload;
        state.tilejson[url] = tilejson;
    })
        .addCase(addSourceMetadata, (state, { payload }) => {
        const { url, metadata } = payload;
        state.metadata[url] = metadata;
    })
        .addCase(changeSourceConfig, (state, { payload }) => {
        const { id, config } = payload;
        state.sources[id] = config;
    })
        .addCase(setExtraSpec, (state, { payload }) => {
        const { sources: currentSources } = state;
        const { sources: sourcesFromExtraSpec = {} } = payload;
        for (const [id, source] of Object.entries(sourcesFromExtraSpec)) {
            currentSources[id] = source;
        }
    })
        .addCase(changeSearch, (state, { payload }) => {
        state.search = payload;
    });
});
export const getSourcesState = createSelector([presetStateSelector], present => present.sources);
export const getSources = createSelector([getSourcesState], sources => sources.sources);
export const getSourcesSearch = createSelector([getSourcesState], state => state.search);
export const getSourcesTileJSON = createSelector([getSourcesState], sources => sources.tilejson);
export const getSourcesMetadata = createSelector([getSourcesState], sources => sources.metadata);
export const getSelectedSourceId = createSelector([getSourcesState], state => state.selectedSource);
export const getSelectedSourceLayerId = createSelector([getSourcesState], state => state.selectedSourceLayer);
export const getSourcesConfigDisplay = createSelector([getSourcesState], state => state.configDisplay);
export const getSelectedSourceLayerLayerId = createSelector([getSourcesState], state => state.selectedSourceLayerLayer);
export const getSelectedSourceLayerLayer = createSelector([
    getLayers,
    getSelectedSourceLayerLayerId,
], findById);
export const getSourcesIds = createSelector([getSources], sources => Object.keys(sources));
export const getSelectedSource = createSelector([
    getSources,
    getSelectedSourceId,
], (sources, selected) => {
    if (!selected)
        return;
    return sources[selected];
});
